import React, { useContext, useState } from "react";
import CartBill from "./CartBill";
import LanguageContext from "../../../utils/Contexts/LanguageContext";
import toast from "react-hot-toast";
import axiosInstance from "../../../utils/Requests/axios";
import GuestPosts from "./GuestPosts";
import LinkTable from "./LinkTable";
import NicheTable from "./NicheTable";
import { useCart } from "../../../utils/Contexts/CartContext";

function OrderDetail({
  setActiveStep,
  activeStep,
  cartData,
  guestPosts,
  guestTotal,
  linkInserts,
  nicheEdits,
  linkTotal,
  nicheTotal,
  getCartData
}) {
  const { t } = useContext(LanguageContext);
  const { setCartCount } = useCart();
  const [emptyContentError, setEmptyContentError] = useState(false);

  const handleDeleteCartItem = (itemUuid) => {
    const url = `/cart/items/${itemUuid}`;
    axiosInstance
      .delete(url)
      .then(() => {
        getCartData();
        setCartCount((prevCount) => prevCount - 1);
        toast.success(t("Item deleted successfully"));
      })
      .catch((error) => {
        console.log(error)
        toast.error(t("Error deleting item"));
      });
  };

  return (
    <div className="row d-xl-flex">
      <div className="col-12 col-xl flex-grow-1">
        {!!guestPosts?.length && (
          <GuestPosts
            guestPosts={guestPosts}
            guestTotal={guestTotal}
            getCartData={getCartData}
            emptyContentError={emptyContentError}
            handleDeleteCartItem={handleDeleteCartItem}
          />
        )}
        {!!linkInserts?.length && (
          <LinkTable
            linkInserts={linkInserts}
            linkTotal={linkTotal}
            handleDeleteCartItem={handleDeleteCartItem}
          />
        )}
        {!!nicheEdits?.length && (
          <NicheTable
            nicheEdits={nicheEdits}
            nicheTotal={nicheTotal}
            handleDeleteCartItem={handleDeleteCartItem}
          />
        )}
      </div>
      <CartBill
        setActiveStep={setActiveStep}
        activeStep={activeStep}
        cartData={cartData}
        guestTotal={guestTotal}
        linkTotal={linkTotal}
        nicheTotal={nicheTotal}
        linkInserts={linkInserts}
        nicheEdits={nicheEdits}
        guestPosts={guestPosts}
        getCartData={getCartData}
        setEmptyContentError={setEmptyContentError}
      />
    </div>
  );
}

export default OrderDetail;
